import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadCities: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi },
) =>
  action$.pipe(
    ofType(actions.STORES_CITIES_ACTIONS.REQUESTED),
    switchMap(({ countryId }) =>
      regionApi.getCitiesByCountry(countryId).pipe(
        switchMap(({ cities, country }) =>
          of(actions.citiesSucceeded(cities, country)),
        ),
        catchError(error => of(actions.citiesFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/loadCities.ts